export default __webpack_public_path__ + "static/media/uploader-abbottXtra-problem-2.e81fbfac.png";